import { useEffect } from 'react'
import { useIntersectionObserver } from 'usehooks-ts'

import {
  isElementBody,
  useClosestScrollableParent,
} from 'components/DataTable/ClosestScrollableParentContext'

import { ReachScrollBottomNotifierProps } from './types'

export function ReachScrollBottomNotifier({
  onScrollBottomReached,
  isLoading,
}: ReachScrollBottomNotifierProps) {
  const closestScrollableParent = useClosestScrollableParent()

  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.5,
    root: isElementBody(closestScrollableParent)
      ? null
      : closestScrollableParent,
    rootMargin: '200px',
  })

  useEffect(() => {
    if (isIntersecting && !isLoading) {
      onScrollBottomReached?.()
    }
  }, [isIntersecting, isLoading, onScrollBottomReached])

  return <div ref={ref}></div>
}
